/** Loads the page again: after a deploy, the new version of the panel comes with it. */
export function reloadPage(): void {
  window.location.reload();
}
